// frontend/src/components/common/DisclosureCaret.jsx
import React from 'react';
import { CaretDown } from '../../icons';
import './DisclosureCaret.css';

/**
 * The chevron on anything that opens — a collapsible tile, a nav section, a
 * Data Health card, a menu button: ˅ while closed, ˄ while open, turning
 * between the two. MUI Accordions, Selects and Autocompletes draw the same
 * turn themselves. DisclosureCaret.test.jsx keeps this and an Accordion's
 * expandIcon the only opening chevrons in the app.
 *
 * Decorative: the toggle it sits in carries aria-expanded.
 */
export default function DisclosureCaret({ open, size, weight, className = '', style }) {
  return (
    <CaretDown
      size={size}
      weight={weight}
      className={['disclosure-caret', open && 'disclosure-caret--open', className].filter(Boolean).join(' ')}
      style={style}
      aria-hidden="true"
    />
  );
}
